import { faDownToLine } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LoadingButton } from '@sorare/core/src/atoms/buttons/LoadingButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { FormControlLabel } from '@sorare/core/src/atoms/inputs/FormControlLabel';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { IntlDate } from '@sorare/core/src/components/IntlDate';
import { Dialog } from '@sorare/core/src/components/dialog';

const StyledVertical = styled(Vertical)`
  padding: var(--double-unit);
`;

type AccountDialogProps = {
  accountDialogOpened: boolean;
  setAccountDialogOpened: (open: boolean) => void;
  startDate: Date;
  setStartDate: (date: Date) => void;
  endDate: Date;
  setEndDate: (date: Date) => void;
  generateAccountExtract: () => void;
  loading: boolean;
};

export const AccountDialog = ({
  accountDialogOpened,
  setAccountDialogOpened,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  generateAccountExtract,
  loading,
}: AccountDialogProps) => {
  return (
    <Dialog
      title={<FormattedMessage defaultMessage="Download CSV" />}
      onClose={() => setAccountDialogOpened(false)}
      open={accountDialogOpened}
    >
      <StyledVertical gap={2}>
        <FormControlLabel
          labelPlacement="top"
          label={<FormattedMessage defaultMessage="Start date" />}
          control={
            <IntlDate value={startDate} onChange={date => setStartDate(date)} />
          }
        />
        <FormControlLabel
          labelPlacement="top"
          label={<FormattedMessage defaultMessage="End date" />}
          control={
            <IntlDate value={endDate} onChange={date => setEndDate(date)} />
          }
        />
        <LoadingButton
          color="tertiary"
          size="small"
          startIcon={<FontAwesomeIcon icon={faDownToLine} />}
          onClick={generateAccountExtract}
          loading={loading}
        >
          <FormattedMessage defaultMessage="Download CSV" />
        </LoadingButton>
      </StyledVertical>
    </Dialog>
  );
};
